import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { Box, CircularProgress, Typography } from '@mui/material';

// Shareable membership-tier links: /m/<slug>.
// Day-pass tiers go straight into the guest mini-reg checkout (no login
// needed); everything else lands on the membership page. Mirrors PlanRedirect.
export default function TierRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const resolve = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'membershipTiers'), where('slug', '==', slug)));
        if (snap.empty) {
          setError('Membership link not found.');
          return;
        }
        const tier = { id: snap.docs[0].id, ...snap.docs[0].data() };
        if (tier.isDayPass) {
          navigate(`/day-pass-checkout?tierId=${tier.id}`, { replace: true });
        } else {
          navigate('/adult-membership', { replace: true });
        }
      } catch (e) {
        setError('Failed to load membership link.');
      }
    };
    resolve();
  }, [slug, navigate]);

  if (error) return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 2 }}>
      <Typography variant="h5" color="error">{error}</Typography>
      <Typography variant="body2" sx={{ color: '#888' }}>The membership link may be invalid or expired.</Typography>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}
